(function () {
    'use strict';

    angular
        .module('app.common')
        .directive('skeletonLoader', skeletonLoader);

    /**
     * Skeleton Loader Directive
     *
     * Usage:
     * <skeleton-loader></skeleton-loader>
     * <skeleton-loader width="100%" height="200px"></skeleton-loader>
     * <skeleton-loader shape="circle" size="50px"></skeleton-loader>
     * <skeleton-loader lines="3"></skeleton-loader>
     * <skeleton-loader lines="5" line-height="20px" line-spacing="15px"></skeleton-loader>
     *
     * Attributes:
     * - width: Width of skeleton (default: '100%')
     * - height: Height of skeleton (default: '20px')
     * - shape: 'rectangle' (default) or 'circle'
     * - size: For circle shape, sets both width and height
     * - lines: Number of skeleton lines to display
     * - line-height: Height of each line (default: '20px')
     * - line-spacing: Bottom margin between lines (default: '15px')
     * - border-radius: Custom border radius (default: '8px')
     */
    function skeletonLoader() {
        return {
            restrict: 'E',
            scope: {
                width: '@',
                height: '@',
                shape: '@',
                size: '@',
                lines: '@',
                lineHeight: '@',
                lineSpacing: '@',
                borderRadius: '@'
            },
            template: `
                <div class="skeleton-loader-wrapper">
                    <div ng-if="!vm.lines"
                         class="skeleton-loader-item animated-background"
                         ng-style="vm.getSingleStyle()">
                    </div>
                    <div ng-if="vm.lines">
                        <div ng-repeat="line in vm.getLineArray() track by $index"
                             class="skeleton-loader-item animated-background"
                             ng-style="vm.getLineStyle($index, $last)">
                        </div>
                    </div>
                </div>
            `,
            link: function (scope) {
                var vm = scope.vm = {};

                // Default values
                var defaults = {
                    width: '100%',
                    height: '20px',
                    lineHeight: '20px',
                    lineSpacing: '15px',
                    borderRadius: '8px'
                };

                /**
                 * Get style object for single skeleton
                 */
                vm.getSingleStyle = function () {
                    var style = {};

                    if (scope.shape === 'circle') {
                        var circleSize = scope.size || '50px';
                        style.width = circleSize;
                        style.height = circleSize;
                        style.borderRadius = '50%';
                    } else {
                        style.width = scope.width || defaults.width;
                        style.height = scope.height || defaults.height;
                        style.borderRadius = scope.borderRadius || defaults.borderRadius;
                    }

                    return style;
                };

                /**
                 * Get style object for line skeleton
                 */
                vm.getLineStyle = function (index, isLast) {
                    var style = {
                        width: scope.width || defaults.width,
                        height: scope.lineHeight || defaults.lineHeight,
                        borderRadius: scope.borderRadius || defaults.borderRadius
                    };

                    // Add spacing between lines (not on last line)
                    if (!isLast) {
                        style.marginBottom = scope.lineSpacing || defaults.lineSpacing;
                    }

                    // Optional: Make last line slightly shorter for visual effect
                    if (isLast && parseInt(scope.lines) > 1) {
                        style.width = '90%';
                    }

                    return style;
                };

                /**
                 * Generate array for ng-repeat based on lines count
                 */
                vm.getLineArray = function () {
                    var count = parseInt(scope.lines) || 1;
                    return new Array(count);
                };
            }
        };
    }
})();
